// extracted by mini-css-extract-plugin
export default {"svg":"ImageStepSecond_svg__e5qDn"};